import React from "react";
import { connect } from "react-redux";
import { ExistingOrders } from "./ExistingOrders";
import {
	CUSTOMER_UNIT_QUOTE_LIST_REQUEST,
	SAVE_SELECTED_EXISTING_ORDER_REQUEST,
	PRINT_PDF_REQUEST,
} from "../../../_utils/constants/Customer";
import { STORE_INFO_REQUEST } from "../../../_utils/constants/admin/StoreInfo";

// Customer Order Requests reuses the shared ExistingOrders grid in quote-view
// mode. For now it reads the same list payload as Unit Quotes; the order-request
// view adds a per-row "View" action that opens the dedicated read-only detail
// page (CustomerOrderRequestDetail), where Approve / Reject live.
const CustomerOrderRequests = (props) => {
	return (
		<ExistingOrders
			{...props}
			isQuoteView={true}
			isOrderRequestView={true}
			jobNoLabel="Quote No."
			pageTitle="Customer Order Requests"
		/>
	);
};

const mapStateToProps = ({ auth, customerInfo, StoreInfo }) => {
	return {
		auth,
		customerInfo: {
			...customerInfo,
			existingOrderList: customerInfo.unitQuoteList,
			totalCount: customerInfo.unitQuoteTotalCount,
			isLoading: customerInfo.isLoading,
			savedExistingOrder: customerInfo.savedExistingOrder,
			printingPdf: customerInfo.printingPdf,
			isPdfProcessing: customerInfo.isPdfProcessing,
		},
		StoreInfo,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		// Customer Order Requests page only: flag the list request so the saga
		// appends isCustomerQuote=true to the GetAllOrderInstallationDetail call.
		fetchExistingOrdersList: (token, sort, page, paginate, listParamState) =>
			dispatch({ type: CUSTOMER_UNIT_QUOTE_LIST_REQUEST, token, sort, page, paginate, listParamState: { ...listParamState, isCustomerQuote: true } }),
		fetchStoreInfo: (token) => dispatch({ type: STORE_INFO_REQUEST, token }),
		saveExistingOrdersList: (token, payload) => dispatch({ type: SAVE_SELECTED_EXISTING_ORDER_REQUEST, token, payload }),
		generatePdf: (token, payload) => dispatch({ type: PRINT_PDF_REQUEST, token, payload }),
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(CustomerOrderRequests);
